import React from 'react';
import { MapPin, Star } from 'lucide-react';
import './Reviews.css';

const Reviews = () => {
  const offices = [
    {
      id: 1,
      name: 'Офис в Московском',
      mapId: '65548354645',
      link: 'https://yandex.ru/maps/org/migrant_pro/65548354645/',
      address: 'г. Москва, 1 микрорайон московский д.39, к.1 (2 этаж)'
    },
    {
      id: 2,
      name: 'Офис в Подольске',
      mapId: '120832200151',
      link: 'https://yandex.ru/maps/org/migrant_pro/120832200151/',
      address: 'Московская область, Подольск, пр-д Авиаторов, д. 1 ТЦ "МОЛОТОК", 2 этаж, павильон А-59'
    }
  ];

  return (
    <>
      <section id="reviews" className="reviews">
        <div className="container">
          <div className="section-header">
            <h2>Отзывы наших клиентов</h2>
            <div className="rating-header">
              <div className="rating-stars">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={24} fill="#FFD700" color="#FFD700" />
                ))}
              </div>
              <p>Рейтинг 5.0 на Яндекс.Картах</p>
            </div>
          </div>

          <div className="reviews-grid">
            {offices.map((office) => (
              <div key={office.id} className="review-widget">
                <h3>
                  <a href={office.link} target="_blank" rel="noopener noreferrer">
                    Отзывы - {office.name}
                  </a>
                </h3>
                <div className="widget-container">
                  <iframe 
                    loading="lazy" 
                    src={`https://yandex.ru/maps-reviews-widget/${office.mapId}?comments`}
                    title={`Отзывы ${office.name}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="map" className="map-section">
        <div className="container">
          <div className="section-header">
            <h2>Наши офисы на карте</h2>
            <p>Удобное расположение в Москве и Московской области</p>
          </div>

          <div className="map-grid">
            {offices.map((office) => (
              <div key={office.id} className="map-widget">
                <div className="map-header">
                  <h3>{office.name}</h3>
                  <p className="map-address">
                    <MapPin size={16} />
                    {office.address}
                  </p>
                </div>
                <div className="map-container">
                  {office.id === 1 ? (
                    <iframe 
                      src="https://yandex.ru/map-widget/v1/org/migrant_pro/65548354645/reviews/?ll=37.352147%2C55.598462&utm_content=more-reviews&utm_medium=reviews&utm_source=maps-reviews-widget&z=17"
                      allowFullScreen={true}
                      title={`Карта ${office.name}`}
                    />
                  ) : (
                    <iframe 
                      src="https://yandex.ru/map-widget/v1/?ll=37.558254%2C55.460120&mode=poi&poi%5Bpoint%5D=37.557846%2C55.459866&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D120832200151&utm_content=more-reviews&utm_medium=reviews&utm_source=maps-reviews-widget&z=18.4"
                      allowFullScreen={true}
                      title={`Карта ${office.name}`}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;